export default __webpack_public_path__ + "static/media/logo-small.462b2305.svg";